import { isNumber } from "../omnia";
import { NutrientType } from "../types";

export function roundNitrogenRequirement(req: number): number {
    if (!isNumber(req)) return req;
    if (req < 1) return 0;
    return Math.ceil(req);
}

export function roundPkRequirement(req: number, minimum: number = 5): number {
    if (!isNumber(req)) return req;
    if (req < minimum) return 0;
    return Math.ceil(req / 5) * 5;
}

export function roundRequirement(req: number, nutrient: NutrientType): number {

    switch (nutrient) {

        case NutrientType.P2O5:
        case NutrientType.K2O:
        case NutrientType.MgO:
            return roundPkRequirement(req);

        default:
            return roundNitrogenRequirement(req);

    }
}
